<div class="tax-cycle-workflow">
  <div class="gt-page-header">
    <h1><i class="fa fa-calendar-check-o"></i>&nbsp;&nbsp;{{ pageTitle }}</h1>
  </div>

  <div class="tax-placemat-status-header">
    <span class="percentile"><b>{{ percentile }}%</b></span>
    <div class="bar">
      <div class="status" [ngStyle]="{ width: percentile + '%' }"></div>
    </div>
  </div>

  @if (!showFilter) {
<div class="gt-filter-container">
    <div class="col">
      <i class="fa fa-spinner fa-spin gt-refresh"></i>
    </div>
  </div>
}

  @if (showFilter) {
<div class="gt-filter-container gt-filter-con">
    <select class="input-sm mar-left year-select" [(ngModel)]="selectedYear">
      @for (year of taxYears; track $index) {
<option [value]="year.value">{{ year.label }}</option>
}
    </select>
    <div class="tax-type-list mar-left">
      <ap-dropdown
        [list]="taxTypeDropdownList"
        [(ngModel)]="taxTypeDetailsSelection"
        [selectType]="'multiple'"
        [enableNgContent]="false"
        [optionName]="'name'"
        [optionValue]="'id'"
        [title]="'Select Tax Type'"
        [inputAriaLabel]="'Tax Type'"
        [hideTitleOnInput]="true"
        [showSearchbox]="true"
        [showSelectAll]="true"
        [clearSearchKeyword]="true"
        (onFilterResult)="onTaxTypeFilterResult($event)">
      </ap-dropdown>
    </div>
    <span class="btn btn-success btn-xs mar-left" (click)="getData()">Filter</span>
    <div class="search-container">
      <i class="fa fa-search search"></i>
      <input class="search-input" placeholder="Enter Keyword" [(ngModel)]="filterData" type="text">
      <i class="fa fa-times close-x" (click)="clearSearch()"></i>
    </div>
  </div>
}

  @if (loading) {
<div class="modal-loader"><i class="fa fa-spinner fa-pulse"></i> Loading...</div>
}

  @if (!loading) {
<div class="gt-mat-container" style="padding-top:10px">
    @for (matItem of data; track $index; let i = $index) {

      <div class="mat col-lg-3 col-md-4 col-sm-6" [ngClass]="{ 'active': matItem.active }">
        <div class="mat-number"><div class="number">{{ matItem.num }}</div></div>
        <div class="mat-header">
          <div class="mat-header-title">{{ matItem.label }}</div>
          <div class="mat-header-date">{{ matItem.date }}</div>
        </div>
        <div class="mat-body">
          <ul>
            @for (row of matItem.values; track $index) {
<li
             
              [hidden]="filterData && !(row.name || '').toLowerCase().includes(filterData.toLowerCase())"
              [ngClass]="{
                'active': row.expanded,
                'complete': row.status === 'complete',
                'locked': row.status === 'locked'
              }">
              <div class="mat-row-item row" (click)="toggleRow(row)">
                <div class="col-xs-1">
                  @if (row.status !== 'locked') {
<i
                    class="fa fa-circle"
                   
                    [ngClass]="{
                      'color-green': row.signoff_status === 'C',
                      'color-red': row.signoff_status === 'N',
                      'color-yellow': row.signoff_status === 'I'
                    }"
                    (click)="onCircleClick($event, row, matItem)"></i>
}
                  @if (row.status === 'locked') {
<i
                    class="fa fa-lock"
                   
                    (click)="onCircleClick($event, row, matItem)"></i>
}
                </div>
                <div class="mat-item-name col-xs-8">{{ row.name }}</div>
                <div class="pull-right actions col-xs-3">
                  <i class="fa fa-file-video-o"></i>
                  <i class="fa fa-user" (click)="onUserClick($event, row, matItem)"></i>
                </div>
              </div>
              @if (row.expanded) {
<ul class="mat-body-shadow">
                @for (childRow of row.children; track $index) {
<li>
                  <div class="row" (click)="onChildClick(row, childRow)">
                    <div class="col-xs-9">{{ childRow.name }}</div>
                    <div class="col-xs-3">
                      <i class="fa fa-external-link"></i>
                      <i class="fa fa-crosshairs" (click)="onCrosshairClick($event, row, matItem, childRow)"></i>
                    </div>
                  </div>
                </li>
}
              </ul>
}
            </li>
}
          </ul>
        </div>
      </div>
      <span>
        @if ((i + 1) % 4 === 0) {
<div class="clearfix visible-lg"></div>
}
        @if ((i + 1) % 3 === 0) {
<div class="clearfix visible-md"></div>
}
        @if ((i + 1) % 2 === 0) {
<div class="clearfix visible-sm"></div>
}
      </span>
    
}
  </div>
}

  @if (noData) {
<div class="row noDataFound">
    <label><strong>No Records found</strong></label>
  </div>
}

  @if (showSignoffModal) {
<div class="tcw-modal-overlay">
    <div class="tcw-modal">
      <div class="modal-header">
        <h4 class="modal-title">User Assign <i (click)="closeSignoffModal()" class="fa fa-times pull-right"></i></h4>
      </div>
      <div class="modal-body no-body-scroll">
        <div class="row activity-row"><h4><b>Activity: {{ currentRow?.name }}</b></h4></div>
        @if (selectedTaxUsers.length > 0) {
<div class="row user-tags">
          @for (user of selectedTaxUsers; track $index) {
<div class="col-md-4">
            <div class="input-group form-group">
              <i class="fa fa-user input-group-addon"></i>
              <span class="btn btn-default label-button form-control user-tag-width">{{ user.value }}</span>
            </div>
          </div>
}
        </div>
}
        <div>
          <h4><b>Status</b></h4>
          <label class="container">Not Started
            <input type="radio" name="signoffStatus" value="N" [(ngModel)]="signoffStatus">
            <span class="checkmark not-started"></span>
          </label>
          <label class="container">In Progress
            <input type="radio" name="signoffStatus" value="I" [(ngModel)]="signoffStatus">
            <span class="checkmark in-prog"></span>
          </label>
          <label class="container">Complete
            <input type="radio" name="signoffStatus" value="C" [(ngModel)]="signoffStatus">
            <span class="checkmark comp"></span>
          </label>
        </div>
      </div>
      <div class="modal-footer">
        <button class="save-button" type="button" (click)="saveSignoffStatus()">Save</button>
        <button class="cancel-button" type="button" (click)="closeSignoffModal()">Cancel</button>
      </div>
    </div>
  </div>
}

  @if (showUserAssignModal) {
<div class="tcw-modal-overlay">
    <div class="tcw-modal tcw-modal-lg">
      <div class="modal-header">
        <h4 class="modal-title">User Assign <i (click)="closeUserAssignModal()" class="fa fa-times pull-right"></i></h4>
      </div>
      <div class="modal-body no-body-scroll">
        <div class="row activity-row"><h4>Activity Name: <b>{{ currentRow?.name }}</b></h4></div>
        <div class="row">
          <div class="col-md-5">
            <label>User Assign</label>
            <div class="input-group">
              <input
                type="text"
                class="form-control"
                placeholder="Search by email or name"
                [(ngModel)]="userSearchText"
                (input)="searchUsers()">
              <span class="input-group-addon"><i class="fa fa-search"></i></span>
            </div>
            @if (userSuggestions.length > 0) {
<div class="suggestions">
              @for (user of userSuggestions; track $index) {
<div class="suggestion-item" (click)="assignUser(user)">
                {{ user.NAME || user.name }}
              </div>
}
            </div>
}
            <label style="margin-top: 8px;">Target Date</label>
            <input type="date" class="form-control" [(ngModel)]="targetDate">
            <label style="margin-top: 8px;">Assigned User</label>
            @if (assignUsers.length > 0) {
<div class="box">
              @for (user of assignUsers; track $index; let i = $index) {
<div class="input-group form-group">
                <i class="fa fa-user input-group-addon"></i>
                <span class="btn btn-default label-button form-control">{{ user.NAME || user.value }}</span>
                <i class="input-group-addon fa fa-times btn btn-danger" (click)="removeAssignedUser(user, i)"></i>
              </div>
}
            </div>
}
            @if (assignUsers.length === 0) {
<div>No users selected</div>
}
          </div>
          <div class="col-md-7">
            <label>Activity Demo Video</label>
            <div><i class="fa fa-file-video-o fa-3x"></i></div>
            <div style="margin-top: 20px;">
              <label>Activity Description</label>
              <p>Comming Soon...</p>
            </div>
          </div>
        </div>
      </div>
      <div class="modal-footer">
        <button class="save-button" type="button" (click)="saveUserAssignment()">Save</button>
        <button class="cancel-button" type="button" (click)="closeUserAssignModal()">Cancel</button>
      </div>
    </div>
  </div>
}

  @if (showActionsModal) {
<div class="tcw-modal-overlay">
    <div class="tcw-modal tcw-modal-md">
      <div class="modal-header">
        <h4 class="modal-title">Actions <i (click)="closeActionsModal()" class="fa fa-times pull-right"></i></h4>
      </div>
      <div class="modal-body no-body-scroll">
        @if (actionsLoading) {
<div class="col-md-12 viewActionLoader">
          <i class="fa fa-spinner fa-spin gt-refresh"></i>
        </div>
}
        @if (noAction) {
<div class="col-md-12 noActionFound">
          <label><strong>No Actions Found</strong></label>
        </div>
}
        <ul class="action-list">
          @for (action of actionList; track $index) {
<li (click)="onActionSelect(action)">
            <i class="fa fa-rss">&nbsp; {{ action.name }}</i>
          </li>
}
        </ul>
      </div>
    </div>
  </div>
}
</div>
